import { useState, type FormEvent } from "react";

const FORM_ADDR = "https://readdy.ai/api/form/da1inbtrlbpoffc5h7k0";

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [message, setMessage] = useState("");

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const data = new FormData(form);
    const honeypot = String(data.get("company_alt") || "").trim();
    if (honeypot) {
      setStatus("success");
      setMessage("订阅成功，感谢你的关注！");
      form.reset();
      setEmail("");
      return;
    }
    data.delete("company_alt");
    setStatus("idle");
    setMessage("");
    try {
      const res = await fetch(FORM_ADDR, {
        method: "POST",
        body: data,
      });
      const text = await res.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string }; message?: string } = {};
      try {
        parsed = JSON.parse(text);
      } catch {
        parsed = {};
      }
      const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || text;
      const isSpam = /spam/i.test(text) || /spam/i.test(serverMsg);
      if (res.ok && !isSpam && parsed?.code === "OK") {
        setStatus("success");
        setMessage(serverMsg || "订阅成功，感谢你的关注！");
        form.reset();
        setEmail("");
      } else {
        setStatus("error");
        setMessage(serverMsg || "订阅失败，请稍后再试。");
      }
    } catch {
      setStatus("error");
      setMessage("网络异常，请稍后再试。");
    }
  };

  return (
    <section id="subscribe" className="relative overflow-hidden bg-primary-500 py-16 md:py-24">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20warm%20coral%20and%20amber%20gradient%20background%20with%20soft%20floating%20bubbles%20and%20stars%2C%20playful%20and%20welcoming%20atmosphere%2C%20minimal%20and%20clean&width=1600&height=700&seq=newsletter-bg-2026&orientation=landscape"
          alt="51动漫网追番资讯订阅背景"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-primary-900/55"></div>
      </div>

      <div className="relative z-10 mx-auto max-w-2xl px-4 text-center md:px-6">
        <h2 className="font-heading text-3xl text-background-50 md:text-4xl">
          订阅追番资讯，精彩更新不错过
        </h2>
        <p className="mt-3 text-sm leading-relaxed text-background-100/85 md:text-base">
          留下你的邮箱，每周为你整理新番时间表、追番推荐与动画更新动态，第一时间送达。
        </p>

        <form
          data-readdy-form="51动漫网追番资讯订阅"
          onSubmit={handleSubmit}
          className="mx-auto mt-8 flex max-w-lg flex-col gap-3 sm:flex-row"
        >
          <input type="text" name="company_alt" className="hp-field" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
          <div className="relative flex-1">
            <i className="ri-mail-line pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-base text-foreground-500"></i>
            <input
              type="email"
              name="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="请输入你的邮箱地址"
              className="h-12 w-full rounded-full bg-background-50 pl-11 pr-4 text-sm text-foreground-900 outline-none ring-1 ring-background-200 transition-shadow focus:ring-2 focus:ring-accent-400"
            />
          </div>
          <button
            type="submit"
            className="inline-flex h-12 items-center justify-center gap-2 rounded-full bg-accent-500 px-7 text-sm font-semibold text-background-50 whitespace-nowrap transition-colors hover:bg-accent-600"
          >
            <i className="ri-send-plane-line"></i>
            立即订阅
          </button>
        </form>

        {status === "success" && (
          <p className="mt-4 inline-flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-2 text-sm text-background-50">
            <i className="ri-checkbox-circle-fill text-accent-300"></i>
            {message}
          </p>
        )}
        {status === "error" && (
          <p className="mt-4 inline-flex items-center gap-2 rounded-full bg-red-500/20 px-4 py-2 text-sm text-background-50">
            <i className="ri-error-warning-fill"></i>
            {message}
          </p>
        )}
      </div>
    </section>
  );
}